import React, { memo, useState } from "react";

export default memo(function FullScreenDropdown() {
  /*
    mode
    */
  const [isFullScreenMode, setIsFullScreenMode] = useState(true);

  /*
    full screen
    */
  const toggleFullscreen = () => {
    const document = window.document;
    document.body.classList.add("fullscreen-enable");

    if (
      !document.fullscreenElement &&
      //@ts-ignore
      !document?.mozFullScreenElement &&
      //@ts-ignore
      !document.webkitFullscreenElement
    ) {
      // current working methods
      setIsFullScreenMode(false);
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
        //@ts-ignore
      } else if (document.documentElement.mozRequestFullScreen) {
        //@ts-ignore
        document.documentElement.mozRequestFullScreen();
        //@ts-ignore
      } else if (document.documentElement.webkitRequestFullscreen) {
        //@ts-ignore
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      setIsFullScreenMode(true);
      //@ts-ignore
      if (document.cancelFullScreen) {
        //@ts-ignore
        document.cancelFullScreen();
        //@ts-ignore
      } else if (document.mozCancelFullScreen) {
        //@ts-ignore
        document.mozCancelFullScreen();
        //@ts-ignore
      } else if (document.webkitCancelFullScreen) {
        //@ts-ignore
        document.webkitCancelFullScreen();
      }
    }

    // handle fullscreen exit
    const exitHandler = () => {
      //@ts-ignore
      if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement)
        document.body.classList.remove("fullscreen-enable");
    };
    document.addEventListener("fullscreenchange", exitHandler);
    document.addEventListener("webkitfullscreenchange", exitHandler);
    document.addEventListener("mozfullscreenchange", exitHandler);
  };
  return (
    <React.Fragment>
      <div className="ms-1 header-item d-none d-sm-flex">
        <button
          onClick={toggleFullscreen}
          type="button"
          className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        >
          <i
            className={isFullScreenMode ? "bx bx-fullscreen fs-22" : "bx bx-exit-fullscreen fs-22"}
          />
        </button>
      </div>
    </React.Fragment>
  );
});
